import React, { ReactNode } from 'react';
import { IActionButtonProps } from './types';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import KubitTooltip from '../../KubitTooltip';

interface IProps extends IActionButtonProps {
  children: ReactNode;
}

const Container = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
`;
const ButtonArea = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${theme.colors.blue500};
  color: ${theme.colors.secondary600};

  &:not(:disabled):hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }

  &:disabled {
    color: ${theme.colors.secondary400};
  }
`;

const ActionButton = ({
  className,
  content,
  actionText,
  actionUrl,
  children,
  ...htmlButtonProps
}: IProps) => (
  <Container className={className}>
    <KubitTooltip
      placement="bottom-end"
      content={content}
      actionText={actionText}
      actionUrl={actionUrl}
    >
      <ButtonArea {...htmlButtonProps} type="button">
        {children}
      </ButtonArea>
    </KubitTooltip>
  </Container>
);

export default ActionButton;
